export const fmtDateGB = (d) => (d ? new Date(d).toLocaleDateString('en-GB') : '—');
